import React, { useContext, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import media from 'css-in-js-media'

import LayoutContext from './LayoutContext'
import FloorplanContext from './FloorplanContext'
import Img from 'gatsby-image'

import CaretLeft from '../svg/caret-left.svg'
import CaretRight from '../svg/caret-right.svg'

import SwiperCore, { Pagination, Navigation } from 'swiper'
import { SwiperSlide } from 'swiper/react'

// install Swiper components
SwiperCore.use([Pagination, Navigation])

// Import Swiper styles
import 'swiper/swiper.scss'

import ZoomIcon from '../svg/arrows-out-simple.svg'
import {
    SlideshowArrowLeft,
    SlideshowArrowRight,
    SlideshowImageWrap,
    SlideshowPagination,
    SlideshowSlideWrapper,
    SlideshowSwiper,
    SlideshowZoomButton,
} from './SlideshowSlider'
import { Variables } from '../styles/Variables'
import { WrapSubtitle } from './HeroBlockSlide'

const Caption = styled.div`
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    font-family: ${Variables.font.body};
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    color: ${Variables.color.white};

    ${media('<desktop')} {
        font-size: 16px;
        line-height: 20px;
        bottom: 20px;
    }
`

const RenderSlider: React.FC<{
    images: object
    id: string
}> = ({ images, id }) => {
    const { isSlideshow, setSlideshow, setZoomOpen, ActiveZomSlide } = useContext(LayoutContext)
    const { setType } = useContext(FloorplanContext)
    const [getRenderIndex, setRenderIndex] = useState(0)

    const activateZoom = (id) => {
        setZoomOpen(id)
        if (ActiveZomSlide) {
            ActiveZomSlide.map((s, i) => {
                if (s.id == id) {
                    s.slider.update()
                    s.slider.slideTo(getRenderIndex, 0)
                    setTimeout(() => {
                        s.slider.update()
                    }, 300)
                }
            })
        }
    }

    useEffect(() => {
        if (isSlideshow.filter((e) => e.id === id).length == 0) {
            setSlideshow((isSlideshow) => [...isSlideshow, { id: id, data: { slideshowImages: images, id: id } }])
        }
    }, [])

    return (
        <SlideshowSwiper
            navigation={{
                prevEl: '.RenderSlideshowPrev',
                nextEl: '.RenderSlideshowNext',
            }}
            speed={1500}
            slidesPerView="1"
            loop={false}
            pagination={{
                el: '.RenderSlideshowPagination',
                type: 'fraction',
            }}
            onSlideChange={(swiper) => {
                const newIndex = swiper.realIndex
                const newCurrentType = swiper.slides[newIndex].getAttribute('type')
                setRenderIndex(newIndex)
                setType(newCurrentType)
            }}
        >
            {images &&
                images.map((slide, index) => {
                    return (
                        <SwiperSlide index={index} key={index} type={slide.type ? slide.type : undefined}>
                            <SlideshowSlideWrapper>
                                <SlideshowImageWrap className="SlideshowImageWrap">
                                    <Img
                                        fluid={slide.fluid}
                                        durationFadeIn={200}
                                        placeholderStyle={{
                                            display: 'none',
                                        }}
                                        alt=""
                                    />
                                </SlideshowImageWrap>
                            </SlideshowSlideWrapper>
                            <WrapSubtitle>
                                <Caption>{slide?.title}</Caption>
                            </WrapSubtitle>
                        </SwiperSlide>
                    )
                })}
            <SlideshowZoomButton
                onClick={() => {
                    activateZoom(id)
                }}
            >
                <ZoomIcon />
            </SlideshowZoomButton>
            <SlideshowPagination className="RenderSlideshowPagination swiper-pagination" />
            <SlideshowArrowLeft className="RenderSlideshowPrev">
                <CaretLeft />
            </SlideshowArrowLeft>
            <SlideshowArrowRight className="RenderSlideshowNext">
                <CaretRight />
            </SlideshowArrowRight>
        </SlideshowSwiper>
    )
}

export default RenderSlider
